/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const acceptInvitationInputDataSchema = z.object({
	invitationToken: z.string(),
	email: z.string(),
	password: z.string(),
})

export type AcceptInvitationInputDataSchema = z.infer<typeof acceptInvitationInputDataSchema>
